module.exports = function () {
    if ( document.querySelector(".adv-search") ) {
        
        const form = $('.adv-search');
        const selectedTime = $('select[name="dates"] :selected');
        const customDates = $('.custom_dates');
        
        if(selectedTime.prop('value') === 'custom'){
            showFields();
        }
        
        $(form).find('select[name="dates"]').change(e => {
            const value = e.target.value;

            if(value === 'custom'){
                showFields();
            }else{
                hideFields();
            }
        })
        
        
        function showFields(){
            customDates.show();
        }
        function hideFields(){
            $('select[name="date_start"]').val("");
            $('select[name="date_end"]').val("");
            customDates.hide();
        }
    }
}